import { create } from 'axios'
import server from '../server'

export const defaultHeaders = {}
const axios = create({ timeout: 30000 })
axios.interceptors.response.use(
  response => { response.ok = true; return response },
  err => {
    if (err.response) {
      err.response.ok = false
      return err.response
    }
    return Promise.reject(err.message)
  }
)
const api = { env: process.env.NODE_ENV }

api.asyncRequest = async (url, type, payload = {}) => {
  url = url.startsWith('/') ? server.backendUrl + url : url
  return axios({
    url,
    method: type,
    data: payload,
    headers: defaultHeaders
  })
}

api.sendHeaders = (headerName, value) => {
  if (value) defaultHeaders[headerName.toLowerCase()] = value
}

api.removeHeaders = headerName => {
  delete defaultHeaders[headerName.toLowerCase()]
}

export default api
